import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact";
import { useState, useRef, useEffect} from "preact/hooks";
import { sortOptions } from "../config";
import Icon from "./elements/Icon";
import Select from "./elements/Select";
import { toggleButtonId } from "./Sidebar";
import MobileSearchToggle from "./MobileCollectionSearchIcon";
import CollectionSearchLogic from "./CollectionSearch";

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
  return (
    <label
      for={toggleButtonId}
      className={`ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ns-align-items-center toggle-btn utility-bar__item ${className}`}
    >
      <span class="button-icon">
        <svg width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
          <line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
          <circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle>
          <circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
        </svg>
      </span>
      <span>Filter</span>
      {selectedFiltersCount > 0 && <span className="ns-total-count">{selectedFiltersCount}</span>}
    </label>
  );
}

export default function Toolbar({ singleViewMobile, setSingleViewMobile }) {
  const { loading, query, response, pageType } = useAppStateSelector(state => pick(state, "loading", "query", "response", "pageType"));

  const categoryPath = response.products?.categoryPath || null;
  const { activeSort, setSort } = useSort(sortOptions);
  const selectedFiltersCount = useSelectedFiltersCount();
  const description = document.querySelector(".nosto-serp-content-native .collection-listing-head div")?.innerHTML || "";
  const handleSortChange = event => {
    event.stopImmediatePropagation();
    event.preventDefault();
    setSort(event.target.getAttribute("sortValue"));
    console.log(event.target.getAttribute("sortValue"), "value");
  };

  const docCount = response.products?.total ?? 0;
  const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`;
  const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }));
  const activeSortLabel = sortOptions.find(o => o.id === activeSort)?.value.name;
 
  const [searchOpen, setSearchOpen] = useState(false);

  const toggleSearch = () => setSearchOpen(open => !open);

  const headerRef = useRef(null);
  const searchBarRef = useRef(null);
  const [isSearchFxied, setIsSearchFixed] = useState(false);

  useEffect(() => {
    if(!searchOpen){
      setIsSearchFixed(false);
      const contentEl = document.querySelector(".collection-content");
      if(contentEl){
        contentEl.classList.remove("padded");
      }
      return;
    }

    const contentEl = document.querySelector(".collection-content") || document.body;
    const globalHeaderEl = document.querySelector("#shopify-section-header");
    const headerEl = headerRef.current;
    const searchBarEl = searchBarRef.current;
    if (!headerEl || !searchBarEl) {
      setIsSearchFixed(false);
      if (contentEl) contentEl.classList.remove("padded");
      return;
    }

    const searchBarHeight = searchBarEl.offsetHeight;
    document.documentElement.style.setProperty('--mobile-search-bar-height', `${searchBarHeight}px`);
    const globalHeaderHeight = globalHeaderEl.offsetHeight;
    document.documentElement.style.setProperty('--mobile-search-bar-top', `${globalHeaderHeight}px`); 
    
    const onScroll = () => {
      const headerBottom = headerEl.getBoundingClientRect().bottom;
      if (headerBottom <= globalHeaderHeight) {
        setIsSearchFixed(true);
        contentEl.classList.add("padded");
      } else {
        setIsSearchFixed(false);
        contentEl.classList.remove("padded");
      }
    };

    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);  

    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      contentEl.classList.remove("padded");
      setIsSearchFixed(false); 
    };

  }, [searchOpen])


  return (
    <>
      {categoryPath && (
        <div class="collection-listing-head mobile-only">
          <h1 class="pagetitle h3-style">{categoryPath}</h1>
          <div dangerouslySetInnerHTML={{ __html: description }}>
          </div>
        </div>
      )}
      {categoryPath && (
          <div
          ref={headerRef}
          class="ns-header-controls ns-d-flex ns-flex-row ns-d-none ns-flex-wrap align-center ns-justify-content-between ns-pt-o ns-pb-1 ns-align-items-center"
          style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
          <ToggleMobileSidebarButton selectedFiltersCount={selectedFiltersCount} />
          {!loading && (
            <span class="ns-d-inline ns-text-align-center ns-d-md-block ns-order-md-first ns-color-black" data-nosto-element="totalResults">
              {totalSummary}
            </span>
          )}
          <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100">
            <div class="utility-bar__right">
              <div class="product-view-container desktop-only">
                <button type="button" class="product-view-btn" data-toggle="2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-down"
                  >
                    <polyline points="14 2 22 2 22 22 14 22 14 2" adata="2 2 10 2 10 22 2 22 2 2"></polyline>
                    <polyline points="2 2 10 2 10 22 2 22 2 2" adata="2 2 10 2 10 22 2 22 2 2"></polyline>
                  </svg>
                </button>
                <button type="button" class="product-view-btn active" data-toggle="4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-chevron-down"
                  >
                    <polyline points="2 2 10 2 10 10 2 10 2 2"></polyline>
                    <polyline points="14 2 22 2 22 10 14 10 14 2"></polyline>
                    <polyline points="14 14 22 14 22 22 14 22 14 14"></polyline>
                    <polyline points="2 14 10 14 10 22 2 22 2 14"></polyline>
                  </svg>
                </button>
              </div>
              <span class="utility-bar__item mobile-only">
                <div class="layout-switchers">
                  <a
                    class={`layout-switch layout-switch--two-columns ${singleViewMobile ? "" : "layout-switch--active"}`}
                    href="#"
                    onClick={() => {
                      setSingleViewMobile(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="2 2 10 2 10 10 2 10 2 2"></polyline>
                      <polyline points="14 2 22 2 22 10 14 10 14 2"></polyline>
                      <polyline points="14 14 22 14 22 22 14 22 14 14"></polyline>
                      <polyline points="2 14 10 14 10 22 2 22 2 14"></polyline>
                    </svg>
                  </a>
                  <MobileSearchToggle searchOpen={searchOpen} toggleSearch={toggleSearch} />
                  {/* This comment explains the div below 
                  <a
                    class={`layout-switch layout-switch--one-column ${singleViewMobile ? "layout-switch--active" : ""}`}
                    href="#"
                    onClick={() => {
                      setSingleViewMobile(true);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-chevron-down"
                    >
                      <polyline points="2 2 22 2 22 22 2 22 2 2"></polyline>
                    </svg>
                  </a>
                  */}
                  <div class="backToTop-button mobile-only">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevrons-up"
                      width="19px"
                      height="18px"
                      viewBox="4 3 18 18"
                      stroke-width="1"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <polyline points="7 11 12 6 17 11"></polyline>
                      <polyline points="7 17 12 12 17 17"></polyline>
                    </svg>
                  </div>
                </div>
              </span>
              <span class="utility-bar__item desktop-only">
                <Select value={activeSortLabel} onChange={e => handleSortChange(e)} className="ns-selection-dropdown-sort-menu" options={options} label={"Sort by"} />
              </span>
            </div>
          </div>
          {searchOpen && (
            <div
              ref={searchBarRef}
              class={`mobile-search-bar mobile-only ${isSearchFxied ? "fixed": ""}`}
            >
              <CollectionSearchLogic categoryPath={categoryPath} />
            </div>
          )}
        </div>
      )}
      {categoryPath && (
        <div class="collection-listing-head desktop-only">
          <h1 class="pagetitle h3-style">{categoryPath}</h1>
          <div dangerouslySetInnerHTML={{ __html: description }}>
          </div>
        </div>
      )}
    </>
  );
}
